// Utility helpers
export const cn = (...classes) => classes.filter(Boolean).join(" ");

export const initials = (name = "") => {
    const parts = name.trim().split(/\s+/);
    if (!parts.length) return "?";
    const first = parts[0]?.[0] ?? "";
    const last = parts.length > 1 ? parts[parts.length - 1]?.[0] : "";
    return (first + last).toUpperCase();
};

export const formatAOA = (value) => {
    if (value == null) return "—";
    if (value >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(2)} mil M`;
    if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)} M`;
    if (value >= 1_000) return `${(value / 1_000).toFixed(1)} K`;
    return value.toLocaleString("pt-PT");
};

// Pass 3 cleanup: PT_DAYS and PT_MONTHS removed in favour of Intl.DateTimeFormat
// in formatPtDate() — preserves only what's actually still used.
export const formatPtDate = (date) => {
    const d = date instanceof Date ? date : new Date(date);
    // Use the active language for locale-aware date formatting (full weekday + month).
    let locale = "pt-PT";
    try {
        if (typeof localStorage !== "undefined" && localStorage.getItem("nx_lang") === "en") {
            locale = "en-GB";
        }
    } catch {
        /* ignore */
    }
    return new Intl.DateTimeFormat(locale, {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
    }).format(d);
};

export const formatRelative = (iso) => {
    if (!iso) return "—";
    const then = new Date(iso).getTime();
    const now = Date.now();
    const diff = Math.floor((now - then) / 1000);
    const isEn = (() => {
        try {
            return typeof localStorage !== "undefined" && localStorage.getItem("nx_lang") === "en";
        } catch {
            return false;
        }
    })();
    if (isEn) {
        if (diff < 60) return "just now";
        if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
        if (diff < 86400) return `${Math.floor(diff / 3600)} h ago`;
        if (diff < 604800) return `${Math.floor(diff / 86400)} d ago`;
    } else {
        if (diff < 60) return "agora mesmo";
        if (diff < 3600) return `há ${Math.floor(diff / 60)} min`;
        if (diff < 86400) return `há ${Math.floor(diff / 3600)} h`;
        if (diff < 604800) return `há ${Math.floor(diff / 86400)} d`;
    }
    const d = new Date(iso);
    return `${d.getDate()}/${(d.getMonth() + 1).toString().padStart(2, "0")}/${d.getFullYear()}`;
};

export const greetingKey = () => {
    const h = new Date().getHours();
    if (h < 12) return "greetingMorning";
    if (h < 19) return "greetingAfternoon";
    return "greetingEvening";
};
